// extracted by mini-css-extract-plugin
export var button = "_be-4";
export var hasDarkBackground = "_be-7";
export var hasLightBackground = "_be-6";
export var iconWrapper = "_be-0";
export var large = "_be-2";
export var medium = "_be-1";
export var small = "_be-5";
export var xsmall = "_be-3";